export default __webpack_public_path__ + "static/media/ringback-tone-nz.e31bfaf5.mp3";